export default "__VITE_ASSET__08ed8cbf__"